{
  "memberGroupProfile.removeFromGroup.error": "그룹에서 멤버를 제거하는 동안 오류가 발생했습니다.",
  "memberGroupProfile.updateGroupPoints.error": "그룹 포인트를 업데이트하는 동안 오류가 발생했습니다.",
  "memberGroupProfile.updateGroupTier.error": "그룹 계층을 업데이트하는 동안 오류가 발생했습니다.",
  "memberGroupProfile.removeFromGroup.deleteDialog.title": "이 멤버를 그룹에서 제거하시겠습니까?<br />",
  "memberGroupProfile.sperator.members": "멤버",
  "memberGroupProfile.sperator.activity": "활동",
  "memberGroupProfile.title": "그룹 프로파일",
  "memberGroupProfile.headerTitle": "그룹 ID: {groupId}",
  "memberGroupProfile.updateTierBtn.label": "계층 업데이트",
  "memberGroupProfile.addNewMembersBtn.label": "멤버 추가",
  "memberGroupProfile.notification": "멤버 프로파일의 모든 업데이트를 확인하는 데 최대 24시간이 걸릴 수 있습니다.",
  "memberProfile.updateMembeerPoints.error": "멤버 포인트를 업데이트하는 동안 오류가 발생했습니다. 다시 시도해 보십시오.",
  "memberProfile.updateMemberTier.error": "멤버 계층을 업데이트하는 동안 오류가 발생했습니다. 다시 시도해 보십시오.",
  "memberProfile.updateMemberPlan.error": "멤버 플랜을 업데이트하는 동안 오류가 발생했습니다. 다시 시도해 보십시오.",
  "memberProfile.updateMemberAdditionalBenefits.error": "멤버 혜택을 업데이트하는 동안 오류가 발생했습니다. 다시 시도해 보십시오.",
  "memberProfile.title": "멤버 프로파일",
  "memberProfile.headerTitle": "멤버 ID: {memberId}",
  "memberProfile.updateTierBtn.label": "계층 업데이트",
  "memberProfile.updatePlanBtn.label": "플랜 마이그레이션",
  "memberProfile.updatePlanBtn.tootip": "그룹에 속한 멤버는 마이그레이션할 수 없습니다.",
  "memberProfile.updateBenefitsBtn.label": "혜택 업데이트",
  "memberProfile.notification": "멤버 프로파일의 모든 업데이트를 확인하는 데 최대 24시간이 걸릴 수 있습니다.",
  "memberProfile.activity.title": "활동",
  "memberProfile.activity.downloadBtn.label": "바우처 리포트 다운로드",
  "memberProfile.activity.downloadBtn.tooltip": "멤버 바우처 리포트를 CSV 형식으로 다운로드하십시오.",
  "memberProfile.activity.pagination.pageSize": "{input} 행 표시",
  "memberProfile.activity.pagination.recordsDisplayed": "{start}-{end}/{total}",
  "memberProfile.duplicateAlert": "이 멤버 ID로 여러 컨택트를 찾았으므로 개인 데이터를 표시할 수 없습니다.",
  "memberProfileOverview.groupProfileBtn.tooltip": "그룹 프로파일",
  "memberProfileOverview.search.error": "검색 중에 오류가 발생했습니다. 다시 검색해 보십시오.",
  "memberProfileOverview.search.noResults.lead": "해당 검색 기준과 일치하는 결과가 없습니다. 다른 검색 기준으로 다시 검색해 보십시오.",
  "memberProfileOverview.search.noItems.title": "해당 검색 기준과 일치하는 결과가 없습니다.",
  "memberProfileOverview.search.noResults.title": "해당 검색 기준과 일치하는 결과가 없습니다.",
  "memberProfileOverview.deleteMemberIcon.tooltip": "멤버 삭제",
  "memberProfileOverview.deleteMemberDialog.headline": "멤버 삭제",
  "memberProfileOverview.deleteMemberDialog.notification": "이 멤버를 삭제하면 Loyalty 멤버십이 영구적으로 취소됩니다. 이 행동은 취소할 수 없습니다. 멤버 데이터는 시스템에 저장됩니다.",
  "memberProfileOverview.deleteMemberDialog.memberToBeDeleted": "삭제할 멤버",
  "memberProfileOverview.deleteMemberDialog.checkboxText": "보고 데이터베이스에서 모든 Loyalty 데이터를 삭제하십시오.",
  "memberProfileOverview.deleteMemberDialog.deleteButton": "삭제",
  "memberProfileOverview.deleteMember.error": "이 멤버를 삭제하는 동안 오류가 발생했습니다. ",
  "memberProfileOverview.deleteGroupDialog.headline": "이 그룹을 삭제하시겠습니까?",
  "memberProfileOverview.deleteGroupDialog.content": "이 그룹을 삭제하면 모든 Loyalty 데이터가 영구적으로 삭제됩니다.",
  "memberProfileOverview.deleteGroup.error": "이 그룹을 삭제하는 동안 오류가 발생했습니다.",
  "memberProfileOverview.deleteGroup.success": "그룹이 삭제되었습니다.",
  "memberProfileOverview.tableHeader.memberID": "멤버 ID",
  "memberProfileOverview.tableHeader.tier": "계층",
  "memberProfileOverview.tableHeader.pointsToSpend": "지출 포인트",
  "memberProfileOverview.tableHeader.joinDate": "가입일",
  "memberProfileOverveiw.memberTable.delete.label": "멤버 삭제",
  "memberProfileOverview.groupTableHeader.groupId": "그룹 ID",
  "memberProfileOverview.groupTableHeader.tier": "계층",
  "memberProfileOverview.groupTableHeader.points": "상태 포인트",
  "memberProfileOverview.groupTableHeader.members": "그룹 멤버",
  "memberProfileOverview.groupTableHeader.created": "생성됨",
  "memberProfileOverveiw.groupTable.delete.label": "그룹 삭제",
  "memberProfileOverveiw.grid.search.tooltip.groupEnabled": "ID로 멤버 및 그룹 검색",
  "memberProfileOverveiw.grid.search.tooltip": "외부 ID로 멤버 검색",
  "memberProfileOverveiw.grid.search.label": "검색",
  "memberProfileOverveiw.grid.btnCreateNewMember.label": "멤버 생성",
  "memberProfileOverveiw.grid.btnCreateNewGroup.label": "멤버 그룹 생성",
  "memberProfileOverveiw.grid.support.title": "Loyalty 지원",
  "memberProfileOverveiw.grid.title": "멤버 프로파일",
  "activityType.online_purchase.name": "구매",
  "activityType.redemption.name": "Loyalty 오퍼",
  "activityType.exclusive_redemption.name": "포인트 액세스",
  "activityType.customer_support.tierUpgrade.name": "계층 업그레이드",
  "activityType.customer_support.tierDowngrade.name": "계층 다운그레이드",
  "activityType.customer_support.cashbackAdded.name": "추가된 캐시백",
  "activityType.customer_support.pointsAdded.name": "{{points_name}}을(를) 추가함",
  "activityType.customer_support.planChange.name": "{planName}/{planId}(으)로 마이그레이션함",
  "activityType.points_expiration.status.name": "상태 {{points_name}} 만료",
  "activityType.points_expiration.cachback.name": "캐시백 만료",
  "activityType.tier_calculation.name": "계산된 계층",
  "activityType.group_create.name": "생성된 그룹",
  "activityType.group_calculation.name": "계산된 그룹 ",
  "activityType.group_calculation.joinMember.name": "멤버가 그룹에 가입함",
  "activityType.group_calculation.leftMember.name": "멤버가 그룹을 탈퇴함",
  "activityType.group_calculation.noChange.name": "그룹 활동",
  "activityType.group_delete.name": "그룹이 닫힘",
  "activityType.additional_benefits.added.name": "추가 혜택을 추가함",
  "activityType.additional_benefits.removed.name": "추가 혜택을 제거함",
  "activityType.member_joined.name": "Loyalty에 가입함",
  "activityType.points_migrated.name": "마이그레이션됨",
  "groupActivity": "그룹 활동",
  "activityElementType.purchase_points.negative": "반품으로 포인트를 제거함",
  "activityElementType.purchase_points.positive.fromCatalog": "카탈로그에서 구매함",
  "activityElementType.purchase_points.positive.fromOnline": "구매",
  "activityElementType.byCustomerSupport": "고객 지원",
  "activityElementType.tierChange": "계층 변경",
  "activityElementType.redemption_points": "포인트에 사용함",
  "activityElementType.redemption_points.voucherRedemptionPoints": "포인트용 바우처",
  "activityElementType.redemption_points.exclusiveRedemptionPoints": "포인트 액세스",
  "activityElementType.redemption_points.voucherRedemptionCashback": "캐시백 바우처",
  "activityElementType.redemption_free": "무료로 사용함",
  "activityElementType.redemption_free.voucher": "무료 바우처",
  "activityElementType.redemption_free.exclusive": "무료 액세스",
  "activityElementType.support_plan_change": "마이그레이션된 플랜",
  "activityElementType.plan_change_points": "마이그레이션된 포인트",
  "activityElementType.plan_change_voucher": "마이그레이션된 보상",
  "activityElementType.contact_state.joinedGroup": "멤버가 그룹에 가입함",
  "activityElementType.contact_state.leftGroup.allGroupActivity": "멤버가 그룹을 탈퇴함",
  "activityElementType.contact_state.leftGroup.onlyMemberLeft": "배포된 공유 포인트",
  "rewardName.cashback": "캐시백",
  "rewardName.tier": "계층",
  "rewardName.pointsAdditional": "추가 {{points_name}}",
  "rewardName.pointsBasic": "기본 {{points_name}}",
  "rewardName.pointsExtra": "기타 {{points_name}}",
  "rewardName.pointsBonus": "보너스 {{points_name}}",
  "rewardName.statusUpgrade": "업그레이드된 상태",
  "rewardName.voucher": "바우처",
  "rewardName.exclusiveAccess": "독점 액세스",
  "error.externalIdError.required": "외부 ID 입력",
  "error.externalIdError.exists": "이 컨택트는 이미 Loyalty 멤버입니다.",
  "error.failToCreateMember": "이 멤버를 생성하는 동안 오류가 발생했습니다.",
  "error.groupNameAlreadyExist": "이 이름은 이미 존재합니다. 고유한 이름을 입력하십시오.",
  "error.groupNameAlreadyExist.WithName": "이 그룹 이름 {groupName}은(는) 이미 존재합니다. 고유한 이름을 입력하십시오.",
  "error.failedToCreateGroup": "이 그룹을 생성하는 동안 오류가 발생했습니다.",
  "error.failedToAddMembersToGroup": "그룹에 멤버를 추가하는 동안 오류가 발생했습니다.",
  "createContactPopup.title": "멤버 생성",
  "createContactPopup.notification": "새 멤버는 Loyalty 관리 설정의 멤버십 설정에 따라 계층에 지정됩니다.",
  "createContactPopup.multiPlanSelect.label": "플랜 선택",
  "createContactPopup.multiPlanSelect.tooltip": "신규 멤버가 가입하는 프로그램을 선택하십시오.",
  "createContactPopup.externalId.tooltip": "신규 Loyalty 멤버를 추가하려면 판매 데이터에서 사용한 것과 동일한 외부 ID를 입력하십시오.",
  "createContactPopup.externalId.label": "외부 ID 입력",
  "success.createGroup": "그룹이 생성되었습니다.",
  "success.addMembersToGroup": "그룹에 멤버가 추가되었습니다.",
  "createGroupPopup.saveBtn.disabled.tooltip.create": "그룹을 생성하려면 그룹에 최소 두 명의 멤버를 추가해야 합니다.",
  "createGroupPopup.saveBtn.disabled.tooltip.modify": "최소 한 명의 멤버를 추가하십시오.",
  "createGroupPopup.saveBtn.disabled.tooltip.create.nameMissing": "그룹 이름을 입력하십시오.",
  "createGroupPopup.title.create": "멤버 그룹 생성",
  "createGroupPopup.title.modify": "멤버 추가",
  "createGroupPopup.notification": "그룹을 생성하려면 그룹에 최소 두 명의 멤버를 추가해야 합니다. 한 멤버가 이미 그룹에 속해 있다면 해당 멤버는 검색 결과에 표시되지 않습니다.",
  "createGroupPopup.selectPlan.label": "플랜 선택",
  "createGroupPopup.selectPlan.tooltip": "서로 다른 플랜의 멤버를 같은 그룹에 추가할 수 없습니다.",
  "createGroupPopup.groupName.tooltip": "그룹 식별자용으로 고유한 이름을 만드십시오. 그룹을 생성한 후에는 이 이름을 변경하거나 복제할 수 없습니다.",
  "createGroupPopup.groupName.label": "그룹 이름",
  "createGroupPopup.addMembers.label": "멤버 추가",
  "createGroupPopup.addMembers.tooltip": "외부 ID로 멤버를 검색하고 그룹에 추가합니다.",
  "groupMemebersTable.header.dateAdded": "추가된 날짜",
  "groupMemebersTable.header.lastActivityDate": "마지막 활동",
  "groupMemebersTable.header.removeFromGroup": "그룹에서 제거",
  "groupProfileActivity.header.activity": "활동",
  "groupProfileActivity.header.tierExpiration": "계층 만료",
  "groupProfileActivity.header.reward": "보상",
  "groupProfileActivity.header.value": "값",
  "groupProfileActivity.header.expiration": "만료",
  "groupProfileActivity.header.orderId": "오더 ID",
  "groupProfileActivity.header.time": "시간",
  "groupProfileActivity.header.admin": "관리자",
  "groupProfileActivity.header.status": "상태",
  "groupProfileActivity.search.tooltip": "날짜, 활동 또는 상태로 검색합니다.",
  "groupProfileActivity.header.totalPoints": "총 포인트",
  "groupProfileActivity.header.totalLoyaltyCredit": "총 Loyalty 크레딧",
  "groupProfileActivity.header.activityType": "활동 유형",
  "memberProfileActivity.search.tooltip": "날짜, 활동, 오더 ID 또는 상태로 검색합니다.",
  "memberProfileAdditionalBenefitsPopup.title": "혜택 업데이트",
  "error.failToLoadData": "데이터를 로드하는 동안 오류가 발생했습니다.",
  "memberProfileAdditionalBenefitsPopup.notification": "멤버 프로파일 또는 Loyalty API에서 추가적인 혜택을 관리할 수 있습니다.",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.label": "혜택 선택",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.tooltip": "이 멤버에 대해 업데이트할 혜택을 선택하십시오. 업데이트를 저장하면 해당 멤버가 이 혜택을 사용할 수 있습니다. 노출된 코드로 상환(사용)한 혜택이 멤버에게 있는 경우 해당 혜택은 멤버의 지갑에 유지됩니다.",
  "memberProfileAdditionalBenefitsPopup.reason.tooltip": "내부 추적용 이유를 입력하십시오.",
  "memberProfileAdditionalBenefitsPopup.reason.label": "사유",
  "memberProfileAdditionalBenefitsPopup.confirmCb.label": "이러한 업데이트가 멤버의 혜택에 영향을 미칠 것임을 이해합니다.",
  "memberProfileChangePlanPopup.title": "플랜 마이그레이션 ",
  "memberProfileChangePlanPopup.selectedPlan.label": "플랜 선택",
  "memberProfileChangePlanPopup.selectRewards.label": "마이그레이션할 보상 선택",
  "memberProfileChangePlanPopup.selectRewards.tooltip": "새 플랜으로 마이그레이션할 보상을 선택하십시오. 보상을 선택하지 않는 경우 멤버는 포인트와 바우처가 없는 가장 낮은 계층에서 새 플랜을 시작합니다.",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.tooltip": "멤버는 새 플랜의 상태 포인트와 계층 설정에 따라 계층에 지정됩니다.",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.label": "상태{{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.label": "잔액 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.tooltip": "포인트 유효 기간이 새 플랜의 설정에 따라 재설정되고 다시 시작됩니다.",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.label": "{{points_name}} 대기 중",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.tooltip": "대기 중인 포인트가 자동으로 승인되어 상태 및 잔액 포인트에 추가됩니다.",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.tooltip": "사용(상환)된 바우처는 Loyalty 지갑/API에 노출된 코드를 사용하는 바우처입니다. 고정 혜택 다중 사용 바우처는 사용되었더라도 마이그레이션되지 않습니다.",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.label": "상환된 바우처",
  "memberProfileChangePlanPopup.migrationConfirmation.label": "마이그레이션 확인",
  "memberProfileChangePlanPopup.migrationConfirmationCb.label": "이 멤버가 새 플랜으로 마이그레이션한 후에는 현재 플랜의 멤버십 및 활동이 취소됩니다.",
  "memberProfileDetails.tierDetails.plan": "플랜 식별자: {planId}",
  "memberProfileDetails.tierDetails.group": "그룹 이름: {groupName}",
  "memberProfileDetails.tierDetails.joinedOn": "가입일: ",
  "memberProfileDetails.tierDetails.createdOn": "생성일:",
  "memberProfileDetails.tierDetails.groupMembers": "그룹 멤버: {groupMembersNum}",
  "memberProfileDetails.tierDetails.personalInfo.firstName": "이름: {firstName}",
  "memberProfileDetails.tierDetails.personalInfo.lastName": "성: {lastName}",
  "memberProfileDetails.tierDetails.personalInfo.email": "전자메일: {email}",
  "memberProfileDetails.tierDetails.tierEntryDate": "계층 진입일",
  "memberProfileDetails.tierDetails.nextTierRequirements": "다음 계층 요구 사항",
  "memberProfileDetails.pointsHistory.currentBalance.title": "현재 잔액",
  "memberProfileDetails.pointsHistory.currentBalance.pointsToSpend": "{{points_name}} 지출 가능",
  "memberProfileDetails.pointsHistory.currentBalance.expiresSoon": "곧 만료됩니다",
  "memberProfileDetails.pointsHistory.currentBalance.groupStatus": "그룹 상태 {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.groupPending": "{{points_name}} 대기 중인 그룹",
  "memberProfileUpdatePointsPopup.add.points.label": "{{points_name}} 추가",
  "memberProfileUpdatePointsPopup.remove.points.label": "{{points_name}} 제거",
  "memberProfileUpdatePointsPopup.remove.spend.label": "잔액에서 제거",
  "memberProfileUpdatePointsPopup.add.spend.label": "잔액에 추가",
  "memberProfileUpdatePointsPopup.title.spend": "잔액 업데이트",
  "memberProfileUpdatePointsPopup.title.points": "포인트 업데이트",
  "memberProfileUpdatePointsPopup.pointsType.spend": "잔액 유형",
  "memberProfileUpdatePointsPopup.pointsType.points": "포인트 유형",
  "memberProfileUpdatePointsPopup.reason.tooltip": "내부 추적용 업데이트 이유를 입력하십시오.",
  "memberProfileUpdatePointsPopup.description.tooltip": "필요한 경우 멤버가 활동 기록에서 볼 수 있도록 업데이트 이유를 입력할 수 있습니다.",
  "memberProfileUpdateTierPopup.options.invitationOnly": "{tierName} [초대 전용]",
  "memberProfileUpdateTierPopup.title": "계층 업데이트",
  "memberProfileUpdateTierPopup.notification": "멤버에게 계층이 지정되면 멤버는 고정 계층 혜택을 받을 자격이 생기며 계층용 계산 설정에 정의된 기간 동안 상태를 유지합니다.",
  "memberProfileUpdateTierPopup.selectTier.placeholder": "-- 계층 선택 --",
  "memberProfileUpdateTierPopup.reason.tooltip": "내부 추적용으로 {text} 행동에 대한 이유를 입력하십시오.",
  "memberProfileUpdateTierPopup.confirmCb.label": "이러한 업데이트가 {text} 멤버의 Loyalty 상태에 영향을 미칠 것임을 이해합니다.",
  "tierDowngrade.points.options.status.name": "멤버의 현재 포인트에 따라 계층을 다운그레이드하십시오.",
  "tierDowngrade.points.options.tier.name": "멤버를 특정 계층으로 다운그레이드하십시오.",
  "tierDowngrade.points.options.tier.tooltip": "상태 포인트는 이 계층에 필요한 최소값으로 업데이트됩니다.",
  "tierDowngrade.spend.options.status.name": "멤버의 현재 Loyalty 크레딧에 따라 계층을 다운그레이드하십시오.",
  "tierDowngrade.spend.options.tier.name": "멤버를 특정 계층으로 다운그레이드하십시오.",
  "tierDowngrade.spend.options.tier.tooltip": "Loyalty 크레딧은 이 계층에 필요한 최소값으로 업데이트됩니다.",
  "tierUpdate.options.tierUpgrade.name": "계층 업그레이드",
  "tierUpdate.options.tierDowngrade.name": "계층 다운그레이드",
  "membersReportDownloadButton.tooltip": "멤버 상태 리포트는 멤버 Loyalty 상태 정보가 포함된 CSV 파일입니다. 다운로드에 수 분이 걸릴 수 있습니다.",
  "membersReportDownloadButton.label": "멤버 상태 리포트 다운로드",
  "updatePointsType.points.options.loyalty": "Loyalty {{points_name}}(상태 {{points_name}} 및 지출 {{points_name}})",
  "updatePointsType.points.options.status": "상태 {{points_name}}만",
  "updatePointsType.points.options.spend": "지출 {{points_name}}만",
  "updatePointsType.spend.options.status": "상태 {{points_name}}만",
  "updatePointsType.spend.options.cashback": "캐시백만",
  "memberPointsUpdateValidator.confirmed.isTrue": "모든 필수 정보를 입력했는지 확인하십시오.",
  "memberPointsUpdateValidator.reason.presence": "내부 추적용 이유를 입력하십시오.",
  "memberPointsUpdateValidator.pointsValue.presence": "포인트 수를 0보다 큰 숫자로 입력하십시오.",
  "memberPointsUpdateValidator.pointsValue.numericality.notInteger": "포인트 수를 0보다 큰 숫자로 입력하십시오.",
  "memberPointsUpdateValidator.pointsValue.numericality.notGreaterThan": "포인트를 0보다 큰 숫자로 입력하십시오.",
  "memberPointsUpdateValidator.pointsValue.numericality.notLessThan": "포인트를 100,000보다 작게 입력하십시오.",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.messageLoyaltyPoints": "제거된 포인트 수는 기존 포인트 수보다 클 수 없습니다.",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.message": "제거된 포인트 수는 기존 포인트 수보다 클 수 없습니다.",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.message": "귀하가 제거하는 포인트 수는 멤버가 현재 보유하고 있는 포인트보다 클 수 없습니다.",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.messageCashback": "제거된 캐시백 수는 기존 캐시백 값보다 클 수 없습니다.",
  "memberTierUpdateValidator.tierDowngradeType": "다운그레이드 유형을 선택하십시오.",
  "memberTierUpdateValidator.selectedTierId": "계층을 선택하십시오.",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.status": "이 멤버를 제거하면 누적된 상태 포인트가 그룹 상태에서 제거됩니다.",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.loyality": "이 멤버를 제거하면 누적된 Loyalty 크레딧이 그룹 상태에서 제거됩니다.",
  "memberGroupProfile.updatePointsBtn.label.points": "포인트 업데이트",
  "memberGroupProfile.updatePointsBtn.label.balance": "잔액 업데이트",
  "memberProfile.updatePointsBtn.label.points": "포인트 업데이트",
  "memberProfile.updatePointsBtn.label.balance": "잔액 업데이트",
  "memberGroupProfile.removeFromGroup.deleteDialog.content": "이 멤버를 제거하면 누적된 {pointType}이(가) 그룹 상태에서 제거됩니다.",
  "memberGroupProfile.updatePointsBtn.label": "{isPoints,select,true {Points} other {Balance}} 업데이트",
  "memberProfile.updatePointsBtn.label": "{isPoints,select,true {Points} other {Balance}} 업데이트",
  "activityType.customer_support.cashbackRemoved.name": "제거된 캐시백 ",
  "activityType.customer_support.pointsRemoved.name": "제거된 {{points_name}}",
  "activityType.points_expiration.toSpend.name": "잔액 {{points_name}} 만료",
  "memberProfileUpdatePointsPopup.confirmed.label": "이러한 업데이트가 {text} 멤버의 Loyalty 상태에 영향을 미칠 것임을 이해합니다."
}
